import { useQuery } from '@tanstack/react-query';
import { fetchEventosNfse } from '../api/EventosNfseApi';
import type { EventoNfse } from '../types';

/** A chave da consulta dos eventos: a manifestação a invalida para a seção se atualizar. */
export const chaveDosEventosNfse = (chaveAcessoDoc?: string | null) =>
  ['servicos-nfse-eventos', chaveAcessoDoc ?? null] as const;

export function useEventosNfse(chaveAcessoDoc?: string | null, enabled = true) {
  return useQuery<EventoNfse[], Error>({
    queryKey: chaveDosEventosNfse(chaveAcessoDoc),
    queryFn: () => fetchEventosNfse(chaveAcessoDoc as string),
    staleTime: 60 * 1000,
    enabled: enabled && !!chaveAcessoDoc,
  });
}
